// extracted by mini-css-extract-plugin
module.exports = {"menuItemWrapper":"menu_menuItemWrapper__cleDJ","menuItemText":"menu_menuItemText__dY_vv","selectedMenuItemText":"menu_selectedMenuItemText___d8JX"};